import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Sientes que la entrevista salió bien, pero no recibes respuesta', 'No entiendes por qué otros candidatos destacan más', 'Llegas preparado, pero no logras ser memorable', 'Respondes bien, pero no generas conexión ni impacto', "Al final no sabes qué preguntar y dices: 'No, creo que ya cubriste todo'"];
  return <section className="py-20 lg:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-145">
      <FadeIn data-id="element-146">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-6 tracking-tight" data-id="element-148">
            Lo que casi nadie te dice sobre las entrevistas
          </h2>
          <p className="text-lg text-gray-600" data-id="element-149">
            La mayoría de los profesionales invierten horas preparando su CV,
            eligiendo su atuendo y ensayando respuestas a posibles preguntas.
            Pero olvidan el factor más importante: preparar preguntas
            estratégicas que conviertan el interrogatorio en una conversación
            real.
          </p>
        </div>
      </FadeIn>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-150">
        {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} className={index === 4 ? 'sm:col-span-2 lg:col-span-1' : ''} data-id="element-151">
            <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm h-full flex items-start gap-4 hover:border-emerald/50 transition-colors" data-id="element-152">
              <div className="mt-1 flex-shrink-0" data-id="element-153">
                <AlertCircle className="w-6 h-6 text-emerald" data-id="element-154" />
              </div>
              <p className="text-navy font-medium leading-relaxed" data-id="element-155">{point}</p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}